import React from "react";
import { TYPE_PC, TYPE_SP } from "../common/defines";
import { Link, openLink } from "../lib/Link";
import PropTypes from "prop-types";
import { getCurrentTime } from "../lib/currentTime";

const lengthSquare = (x, y) => {
  return x * x + y * y;
}

export const isVisibleContent = params => {
  if (!params) {
    return false;
  }
  const currentTime = getCurrentTime();
  return (
    (!params.startTime || currentTime > params.startTime * 1000) &&
    (!params.endTime || currentTime < params.endTime * 1000)
  );
};

export class DynamicContent extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  /* iOS 11 以下 + Slickで、スライド内のリンクが効かない
  （おそらく、onTouchStart / onTouchEndをcaptureしてしまっているため）
   問題を回避するため、タッチデバイスでの動作をエミュレートする
  */
  lastTouch = null;
  torcX = null;
  torcY = null;
  onTouchStart = (e) => {
    console.log(e);
    this.lastTouch = e.targetTouches[0];
  }
  onTouchEnd = (e) => {
    const touch = e.nativeEvent.changedTouches[0];
    console.log(this.lastTouch, touch, lengthSquare(this.lastTouch.pageX - touch.pageX, this.lastTouch.pageY - touch.pageY));
    if (typeof linkHref !== 'object') {
      if (lengthSquare(this.lastTouch.pageX - touch.pageX, this.lastTouch.pageY - touch.pageY) < 10) {
        this.torcX = touch.pageX;
        this.torcY = touch.pageY;
        this.onClick(e);
      }
    }
  }
  onClick = (e) => {
    console.error('#');
    e.stopPropagation();
    e.preventDefault();
    const params = this.props.params;
    const linkHref = this.getLinkHref();
    if (typeof linkHref !== 'object') {
      if (linkHref && (params.external || params.targetBlank)) {
        if (params.targetBlank) {
          window.open(linkHref, '_blank')
        } else {
          location.href = linkHref;
        }
      } else if (linkHref && !params.external) {
        openLink(this.context.router.history, { href: linkHref });
      }
    } else {
      if (this.torcX === null || this.torcY === null) {
        this.torcX = e.pageX;
        this.torcY = e.pageY;
      }
      const clientRect = e.currentTarget.getBoundingClientRect() ;
      const positionX = clientRect.left + window.pageXOffset ;
      const positionY = clientRect.top + window.pageYOffset ;

      const params = this.props.params;
      // 各リンクの幅、高さに対する％(x / width)(y / hgithg)
//      console.log("x = " + (this.torcX - positionX) / e.currentTarget.width + " y = " + (this.torcY - positionY) / e.currentTarget.height);
      for (var i = 0; i < linkHref.length; i++) {
        var ln = linkHref[i];
        if ((e.currentTarget.width * ln.sx) <= (this.torcX - positionX) && (this.torcX - positionX) <= (e.currentTarget.width * ln.ex) &&
          (e.currentTarget.height * ln.sy) <= (this.torcY - positionY) && (this.torcY - positionY) <= (e.currentTarget.height * ln.ey)) {
          if (ln.linkHref && (params.external || params.targetBlank)) {
            this.torcX = null;
            this.torcY = null;
            if (params.targetBlank) {
              window.open(ln.linkHref, '_blank')
            } else {
              location.href = ln.linkHref;
            }
          } else if (ln.linkHref && !params.external) {
            openLink(this.context.router.history, { href: ln.linkHref });
          }
        }
      }
      this.torcX = null;
      this.torcY = null;
    }
  }
  getLinkHref() {
    const params = this.props.params;
    return (this.props.type === TYPE_SP ? params.linkHrefSp : params.linkHrefPc) ||
    params.linkHref;
  }
  render() {
    const params = this.props.params;
    if (!isVisibleContent(params)) {
      return <div />;
    }
    const linkHref = this.getLinkHref();
    const content = (() => {
      if (typeof params.html === 'string') {
        if (typeof params.html === 'string') {
          return <div dangerouslySetInnerHTML={{ __html: params.html }} />;
        } else if (params.html) {
          return <div>{params.html}</div>;
        }
      } else if (this.props.type === TYPE_PC) {
        if (typeof params.htmlPC === 'string') {
          return <div dangerouslySetInnerHTML={{ __html: params.htmlPC }} />;
        } else if (params.htmlPC) {
          return <div>{params.htmlPC}</div>;
        } else if (typeof linkHref !== 'object' && (params.imageSrc || params.imageSrcPc)) {
          const imageSrc = params.imageSrcPc || params.imageSrc;
          return <img src={imageSrc} alt={params.text}/>;
        } else if (typeof linkHref === 'object' && (params.imageSrc || params.imageSrcPc)) {
          const imageSrc = params.imageSrcPc || params.imageSrc;
          return <img
            src={imageSrc}
            alt={params.text}
            onTouchStart={this.onTouchStart}
            onTouchEnd={this.onTouchEnd}
            onClick={this.onClick}
           />;
        } else {
          return null;
        }
      } else if (this.props.type === TYPE_SP) {
        if (typeof params.htmlSP === 'string') {
          return <div dangerouslySetInnerHTML={{ __html: params.htmlSP }} />;
        } else if (params.htmlSP) {
          return <div>{params.htmlSP}</div>;
        } else if (typeof linkHref !== 'object' && (params.imageSrc || params.imageSrcSp)) {
          const imageSrc = params.imageSrcSp || params.imageSrc;
          return <img src={imageSrc} alt={params.text}/>;
        } else if (typeof linkHref === 'object' && (params.imageSrc || params.imageSrcSp)) {
          const imageSrc = params.imageSrcSp || params.imageSrc;
          return <img
            src={imageSrc}
            alt={params.text}
            onTouchStart={this.onTouchStart}
            onTouchEnd={this.onTouchEnd}
            onClick={this.onClick}
           />;
        } else {
          return null;
        }
      }
    })();
    if (!content) {
      return <div />;
    } else if (typeof linkHref !== 'object' && linkHref && (params.external || params.targetBlank)) {
      return (
        <a
          href={linkHref}
          className={this.props.className}
          style={this.props.style}
          target={params.targetBlank ? "_blank" : undefined}
          onTouchStart={this.onTouchStart}
          onTouchEnd={this.onTouchEnd}
        >
          {content}
        </a>
      );
    } else if (typeof linkHref !== 'object' && linkHref && !params.external) {
      return (
        <Link
          to={linkHref}
          className={this.props.className}
          style={this.props.style}
          onTouchStart={this.onTouchStart}
          onTouchEnd={this.onTouchEnd}
        >
          {content}
        </Link>
      );
    } else {
      return <div
        className={this.props.className}
        style={this.props.style}
      >{content}</div>;
    }
  }
}



// WEBPACK FOOTER //
// ./common/DynamicContent.jsx